"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isLegacyHomeownershipEntity = exports.getCoverageAreaLabel = exports.getLoanTypeAndProductLabels = void 0;

require("core-js/modules/es6.array.map.js");

var _get2 = _interopRequireDefault(require("lodash/get"));

var _capitalize2 = _interopRequireDefault(require("lodash/capitalize"));

var _constants = require("../../constants");

var _mortgages = require("../../selectors/mortgages");

/**
 * @module
 *
 * @description Mortgage utils
 */

/**
 * Gather readable representations of loan types and products.
 *
 * @param {Object} marketplaceEntity - The marketplace entity
 * @return {Array} - The array of loan type & product labels
 */
var getLoanTypeAndProductLabels = function getLoanTypeAndProductLabels(marketplaceEntity) {
  var featuredLoanAttributes = (0, _mortgages.getFeaturedLoanAttributes)(marketplaceEntity);
  return (featuredLoanAttributes === null || featuredLoanAttributes === void 0 ? void 0 : featuredLoanAttributes.map(function (attr) {
    return _constants.MORTGAGES_FEATURED_LOAN_ATTRIBUTES_TO_LABELS[attr];
  })) || [];
};
/**
 * Get readable representation of coverage area.
 * @param {Object} marketplaceEntity - The marketplace entity
 * @return {String} - The coverage area label.
 */


exports.getLoanTypeAndProductLabels = getLoanTypeAndProductLabels;

var getCoverageAreaLabel = function getCoverageAreaLabel(marketplaceEntity) {
  var coverageArea = (0, _mortgages.getNationalOrRegional)(marketplaceEntity);
  return coverageArea && (0, _capitalize2.default)(coverageArea);
};
/**
 * Is the entity from Homeownership or Marketplace?
 * @deprecated
 *
 * @param {Object} entity - The Mortgages entity (from Homeownership or Marketplace).
 * @return {Boolean} - Whether the entity is from Homeownership service?
 */


exports.getCoverageAreaLabel = getCoverageAreaLabel;

var isLegacyHomeownershipEntity = function isLegacyHomeownershipEntity(entity) {
  return (0, _get2.default)(entity, 'type') === 'nw_lender';
};

exports.isLegacyHomeownershipEntity = isLegacyHomeownershipEntity;